import { Component, inject, OnInit, Optional } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet],
    template: '<router-outlet></router-outlet>',
    styles: []
})
export class AppComponent implements OnInit {
    title = 'Enterprise Scheduler';
    private swUpdate = inject(SwUpdate, { optional: true });

    ngOnInit(): void {
        console.log(`[App] v${environment.appVersion}`);

        if (!this.swUpdate?.isEnabled) return;

        this.swUpdate.versionUpdates.pipe(
            filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
        ).subscribe(evt => {
            console.log(`[SW] Update ready — current: ${JSON.stringify(evt.currentVersion)}, latest: ${JSON.stringify(evt.latestVersion)}`);
            document.location.reload();
        });

        this.swUpdate.checkForUpdate().then(hasUpdate => {
            if (hasUpdate) console.log('[SW] Update found on load');
        });

        setInterval(() => this.swUpdate!.checkForUpdate(), 6 * 60 * 60 * 1000);
    }
}
